<template>
</template>

<script>
export default {
  name: "Brands"
}
</script>

<style scoped>

</style>